import React, { useState, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useRegistration } from '../../context/RegistrationContext';

const PhoneInputField = ({ control, name, label, required, errors, setValue }) => {
  // Stav pre aktuálne vybranú krajinu
  const [selectedCountry, setSelectedCountry] = useState('sk');
  
  // Získanie kontextu registrácie pre aktualizáciu hodnoty krajiny
  const { dispatch, actionTypes } = useRegistration();
  
  const customStyles = {
    container: {
      width: '100%',
    },
    input: {
      width: '100%',
      height: '42px',
      padding: '0.5rem 0.75rem 0.5rem 58px', 
      borderRadius: '0.375rem',
      border: '1px solid #e2e8f0',
      backgroundColor: '#fff',
      fontSize: '1rem',
      lineHeight: '1.5',
      boxSizing: 'border-box',
    },
    button: {
      backgroundColor: '#f8fafc',
      border: '1px solid #e2e8f0',
      borderRadius: '0.375rem 0 0 0.375rem',
      height: '42px',
      width: '52px',
    },
    buttonFlagsContainer: {
      marginRight: '4px',
    },
    buttonFlag: {
      marginRight: '5px',
    },
    dropdown: {
      marginTop: '8px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      borderRadius: '0.375rem',
    },
  };

  // Funkcia na konverziu kódu krajiny na slovenský názov
  const getCountryName = (countryCode) => {
    switch(countryCode) {
      case 'sk': return 'Slovensko';
      case 'cz': return 'Česká republika';
      case 'pl': return 'Poľsko';
      case 'hu': return 'Maďarsko';
      case 'de': return 'Nemecko';
      case 'at': return 'Rakúsko';
      default: return null; // pre ostatné krajiny vrátime null a použijeme názov z knižnice
    }
  };

  // Inicializácia defaultnej krajiny na Slovensko a nastavenie v kontexte formulára
  useEffect(() => {
    setSelectedCountry('sk');
    
    // Nastavenie krajiny na Slovensko ako predvolenú hodnotu
    dispatch({
      type: actionTypes.UPDATE_FORM_DATA,
      payload: { krajina: 'Slovensko' }
    });
  }, [dispatch, actionTypes]);

  // Funkcia handlePhoneChange bola odstránená, pretože onChange nie je dostupný v tomto scope

  return (
    <div className="form-group">
      <label htmlFor={name} className="block text-sm font-medium mb-1">
        {label} {required && <span className="text-accent">*</span>}
      </label>
      
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <div className="relative">
            <PhoneInput
              country={selectedCountry}
              value={value}
              onChange={(inputValue, data, event) => {
                // Základná aktualizácia hodnoty
                onChange(inputValue);
                
                // Ak máme dáta o krajine, aktualizujeme aj krajinu
                if (data && data.countryCode) {
                  setSelectedCountry(data.countryCode);
                  
                  // Získanie názvu krajiny
                  const countryName = getCountryName(data.countryCode) || data.name;
                  
                  // Aktualizujeme krajinu v kontexte aplikácie
                  dispatch({
                    type: actionTypes.UPDATE_FORM_DATA,
                    payload: { krajina: countryName }
                  });
                  
                  // Aktualizujeme hodnotu krajiny priamo vo formulári
                  if (setValue) {
                    setValue('krajina', countryName);
                  }
                }
                
                // Ak sa input vymazal, nastavme default krajinu
                if (!inputValue) {
                  setSelectedCountry('sk');
                  
                  // Aktualizujeme krajinu v kontexte aplikácie
                  dispatch({
                    type: actionTypes.UPDATE_FORM_DATA,
                    payload: { krajina: 'Slovensko' }
                  });
                  
                  // Aktualizujeme hodnotu krajiny priamo vo formulári
                  if (setValue) {
                    setValue('krajina', 'Slovensko');
                  }
                }
              }}
              countryCodeEditable={true}
              inputProps={{
                id: name,
                required: required,
                style: customStyles.input,
                tabIndex: 0,
                onKeyDown: (e) => {
                  // Pre klávesu TAB nechoame štandardné správanie
                  if (e.key === 'Tab') {
                    return;
                  }
                  
                  // Pre klávesu ENTER simulujeme klávesu TAB
                  if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13 || e.charCode === 13) {
                    e.preventDefault();
                    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
                    const form = e.target.form;
                    if (form) {
                      const focusable = Array.from(form.querySelectorAll(focusableElements));
                      const index = focusable.indexOf(e.target);
                      if (index > -1 && index < focusable.length - 1) {
                        focusable[index + 1].focus();
                      }
                    }
                  }
                }
              }}
              containerStyle={customStyles.container}
              buttonStyle={customStyles.button}
              dropdownStyle={customStyles.dropdown}
              specialLabel={''}
              enableSearch={true}
              disableSearchIcon={false}
              searchPlaceholder="Hľadať krajinu..."
              placeholder="+421 9XX XXX XXX"
              preferredCountries={['sk', 'cz', 'pl', 'hu', 'de', 'at']}
              regions={'europe'}
              autoFormat={true}
              enableAreaCodes={true}
              disableCountryCode={false}
              enableLongNumbers={true}
              preserveOrder={['onlyCountries', 'preferredCountries']}
            />
          </div>
        )}
      />
      
      {errors[name] && (
        <p className="error-message">{errors[name].message}</p>
      )}
    </div>
  );
};

export default PhoneInputField;
